import React, { useState } from 'react';
import DashboardStyle from "./Dashboard.module.css";
import Sidebar from '../../Component/MainDashboard/Sidebar';
import MessagesComp from "../../Component/MainDashboard/MessagesComp";

const Messages = () => {
    const [hamburgerMenu, sethamburgerMenu] = useState("in-active");

    return (
        <div className={DashboardStyle.dashboardCont}>
            <div className={DashboardStyle.dashboardContSidebar}>
                <Sidebar hamburgerMenu={hamburgerMenu} sethamburgerMenu={sethamburgerMenu} />
            </div>
            <div className={DashboardStyle.dashboardContMain}>
                <MessagesComp sethamburgerMenu={sethamburgerMenu} />
            </div>
        </div>
    )
}

export default Messages
